(function () {
  var body = document.body;
  var menuToggle = document.querySelector(".site-header__menu-toggle");

  if (menuToggle) {
    menuToggle.addEventListener("click", function () {
      var isOpen = body.classList.toggle("menu-open");
      menuToggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
    });
  }

  // Smooth-scroll for menu links; close mobile menu first if open
  var siteWrapper = document.querySelector(".site-wrapper");
  var menuLinks = document.querySelectorAll(
    ".mobile-menu__nav a, .site-header__nav a"
  );

  function scrollTo(target) {
    target.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  menuLinks.forEach(function (link) {
    link.addEventListener("click", function (e) {
      var href = link.getAttribute("href");
      if (!href || href.charAt(0) !== "#") return;

      var target = document.querySelector(href);
      if (!target) return;

      e.preventDefault();

      var wasMenuOpen = body.classList.contains("menu-open");

      if (!wasMenuOpen) {
        scrollTo(target);
        return;
      }

      // Wait for the wrapper transform to fully end before scrolling,
      // otherwise the wrapper's containing block keeps the fixed header
      // attached to it during scroll.
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        if (siteWrapper) {
          siteWrapper.removeEventListener("transitionend", onEnd);
        }
        scrollTo(target);
      }
      function onEnd(ev) {
        if (ev.propertyName === "transform") finish();
      }

      if (siteWrapper) {
        siteWrapper.addEventListener("transitionend", onEnd);
      }

      body.classList.remove("menu-open");
      if (menuToggle) {
        menuToggle.setAttribute("aria-expanded", "false");
      }

      // Fallback in case transitionend doesn't fire (no transition, interrupted, etc.)
      setTimeout(finish, 500);
    });
  });

  var slides = document.querySelectorAll(".hero__slide");
  if (slides.length > 1) {
    var current = 0;
    setInterval(function () {
      slides[current].classList.remove("is-active");
      current = (current + 1) % slides.length;
      slides[current].classList.add("is-active");
    }, 5000);
  }

  var videoCards = document.querySelectorAll("[data-youtube-id]");
  videoCards.forEach(function (card) {
    card.addEventListener("click", function (e) {
      e.preventDefault();
      var id = card.getAttribute("data-youtube-id");
      var thumb = card.classList.contains("video-thumb")
        ? card
        : card.querySelector(".video-thumb");
      if (!thumb) return;

      var iframe = document.createElement("iframe");
      iframe.src =
        "https://www.youtube.com/embed/" +
        id +
        "?autoplay=1&rel=0";
      iframe.setAttribute("frameborder", "0");
      iframe.setAttribute(
        "allow",
        "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      );
      iframe.setAttribute("allowfullscreen", "");
      iframe.style.width = "100%";
      iframe.style.height = "100%";
      iframe.style.border = "0";

      thumb.innerHTML = "";
      thumb.style.background = "#000";
      thumb.appendChild(iframe);
    });
  });

  // Contact modal — move to body so it escapes the wrapper's containing block
  var contactModal = document.getElementById("contact-modal");
  if (contactModal && contactModal.parentNode !== body) {
    body.appendChild(contactModal);
  }

  function openModal(modal) {
    if (body.classList.contains("menu-open")) {
      body.classList.remove("menu-open");
      if (menuToggle) menuToggle.setAttribute("aria-expanded", "false");
    }
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    body.style.overflow = "hidden";
  }

  function closeModal(modal) {
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    body.style.overflow = "";
  }

  var modalTriggers = document.querySelectorAll("[data-modal-target]");
  modalTriggers.forEach(function (trigger) {
    trigger.addEventListener("click", function (e) {
      e.preventDefault();
      var targetId = trigger.getAttribute("data-modal-target");
      var modal = document.getElementById(targetId);
      if (modal) openModal(modal);
    });
  });

  if (contactModal) {
    // Backdrop click
    contactModal.addEventListener("click", function (e) {
      if (e.target === contactModal) closeModal(contactModal);
    });
  }

  var modalCloseButtons = document.querySelectorAll("[data-modal-close]");
  modalCloseButtons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      var modal = btn.closest(".contact-modal");
      if (modal) closeModal(modal);
    });
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      var open = document.querySelector(".contact-modal.is-open");
      if (open) closeModal(open);
    }
  });

  var contactForm = document.getElementById("contact-form");
  if (contactForm) {
    contactForm.addEventListener("submit", function (e) {
      e.preventDefault();
      alert(
        "Thanks for reaching out! (Placeholder — wire up email backend)"
      );
      contactForm.reset();
      var modal = contactForm.closest(".contact-modal");
      if (modal) closeModal(modal);
    });
  }
})();
